import * as THREE from 'three';
import AbstractObject from "@scene/misc/object";
// import SafetyBarrierObject from '../safety-barrier.object';
import textureImg from '../../../../assets/textures/steel_2.jpg';

export const CladdingTypes = {
  None: "none",
  Glass: "glass",
  Metallic: "metallic"  
};

const glassMaterial = new THREE.MeshLambertMaterial({
  transparent: true,
  color: new THREE.Color(0x419ce1),
  emissive: new THREE.Color(0x419ce1),
  opacity: 0.25
});

const defaultTexture = new THREE.TextureLoader().load(textureImg);

const metallicMaterial = new THREE.MeshLambertMaterial({
  color: 0x777777,
  side: THREE.DoubleSide,
  map: defaultTexture
});

export default class Cladding extends AbstractObject {

	constructor(options) {
		super(options);
		this.calculateSize();

		if (this.size.width > 0 && this.size.height > 0) {
			this.cladding = this.getCladding();
			this.object.addMesh(this.cladding);
		}
	}
	
  get position() {
    return this.object.mesh.position;
  }

  get size() {
    return {
      width: this.options.cladding.width,
      height: this.options.cladding.height,
      depth: this.options.cladding.depth,
    };
  }

	calculateSize() {
		this.options.profileWidth = 3;
		this.options.profileHeight = 3;
		if (this.options.beamGeometry) {
			let bbox = this.options.beamGeometry.boundingBox;
			// half of the profile on each side
			this.options.profileWidth = Math.abs(bbox.max.x - bbox.min.x); 
			// half of the top profile; top profile is the same beam rotated
			this.options.profileHeight = Math.abs(bbox.max.x - bbox.min.x) / 2;
		}

		let offset = this.options.cladding.offset;
		this.options.cladding.width = this.options.barrier.dpot - offset.left - offset.right - this.options.profileWidth;
		this.options.cladding.height = this.options.barrier.height - offset.top - offset.bottom - this.options.profileHeight;
		// mostly for profile RHS - the profile is placed on top of the stays not within; add the stayHeight
		this.options.cladding.height += this.options.stayHeight / 2;
	}

	getCladding() {
		const object = new THREE.Object3D();

		this.geometry = this.getCuboidGeometry(this.size.width, this.size.height, this.size.depth);
		const material = this.options.cladding.type === CladdingTypes.Metallic ? metallicMaterial : glassMaterial;
		const mesh = new THREE.Mesh(this.geometry, material);
		this.rotateMesh(mesh);
		object.add(mesh);

		const clamps = this.getClamps();
		object.add(clamps);
		
		this.setCladdingPosition();
		return object;
	}

	// getGeometry() {
	// 	// switch (this.options.object.type) {
	// 	// 	case SafetyBarrierObject.types.EDGE_SLAB: {

	// 	// 	}
	// 	// }
	// 	const shape = new THREE.Shape();
	// 	shape.moveTo(0, 0);
	// 	shape.lineTo(this.size.width, 0);
	// 	shape.lineTo(this.size.width, this.size.height);
	// 	shape.lineTo(0, this.size.height);
	// 	shape.lineTo(0, 0);

	// 	const extrudeSettings = {
	// 		depth: this.size.depth,
	// 		bevelEnabled: false
	// 	};

	// 	const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
	// 	return geometry;
	// }

	rotateMesh(mesh) {
		mesh.rotateY(Math.PI / 2);
	}

	setCladdingPosition() {
		let offset = this.options.cladding.offset;
		this.object.mesh.position.x -= this.size.depth / 2;
		this.object.mesh.position.y += offset.bottom; // + this.options.profileHeight / 2 - offset.top;
		this.object.mesh.position.z += -offset.left - this.options.profileWidth / 2;
	}

	getClamps() {
		const clamps = new THREE.Object3D();
		const clampHeight = 50;
		const clampDepth = 6;
    const clampMaterial = new THREE.MeshLambertMaterial({
      color: 0xCCCCCC,
      side: THREE.DoubleSide,
      map: defaultTexture
    });

		let offset = this.options.cladding.offset;
		let leftClampsGeom = this.getCuboidGeometry(offset.left * 3, clampHeight, this.size.depth + clampDepth);
		let bottomLeft = new THREE.Mesh(leftClampsGeom, clampMaterial);
		this.rotateMesh(bottomLeft);
		bottomLeft.position.x = -clampDepth / 2;
		bottomLeft.position.y = this.size.height / 6;
		bottomLeft.position.z = offset.left;
		clamps.add(bottomLeft);
		let topLeft = bottomLeft.clone();
		topLeft.position.y = -offset.bottom + this.size.height - this.size.height / 6 - offset.top;
		clamps.add(topLeft);
		
		let rightClampsGeom = this.getCuboidGeometry(offset.right * 3, clampHeight, this.size.depth + clampDepth);
		let bottomRight = new THREE.Mesh(rightClampsGeom, clampMaterial);
		this.rotateMesh(bottomRight);
		bottomRight.position.x = -clampDepth / 2;
		bottomRight.position.y = this.size.height / 6;
		bottomRight.position.z = -this.size.width + offset.right * 2;
		clamps.add(bottomRight);
		let topRight = bottomRight.clone();
		topRight.position.y = -offset.bottom + this.size.height - this.size.height / 6 - offset.top;
		clamps.add(topRight);

		return clamps;
	}

	getCuboidGeometry(width, height, depth) {
		const shape = new THREE.Shape();
		shape.moveTo(0, 0);
		shape.lineTo(width, 0);
		shape.lineTo(width, height);
		shape.lineTo(0, height);
		shape.lineTo(0, 0);

		const extrudeSettings = {
			depth: depth,
			bevelEnabled: false
		};

		const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
		return geometry;
	}

}



// WEBPACK FOOTER //
// ./src/object-view/generators/safety-barrier/objects/cladding.js